"use client";

import { useSDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import {
  ComponentLoggingEventParams,
  LoggingEventParams,
} from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { Button } from "@faire/web/slate/Button";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import React from "react";

export const SDUITypographySuffixRenderer: React.FC<{
  suffixCTA: string;
  onClickActions: IAction[];
  link: string | undefined;
  loggingData: LoggingEventParams | undefined;
  color?: string;
}> = ({ suffixCTA, onClickActions, link, loggingData, color }) => {
  const onClickHandler = useSDUIOnClickHandler(
    onClickActions,
    loggingData ?? ComponentLoggingEventParams.build({})
  );
  return (
    <Button
      variant="tertiary"
      onClick={onClickHandler}
      linkTo={link}
      tertiaryColor={color}
    >
      {suffixCTA}
    </Button>
  );
};
